import { Provider } from "@angular/core";

/**
 * tokens
 */
import {
  AUTH_JWT,
  AUTH_ACCESS_TOKEN,
  AUTH_IS_LOGGED_IN,
  AUTH_CONTROLS,
  AUTH_SESSION_MANAGEMENT,
  AUTH_LOGIN,
  AUTH_LOGOUT,
} from "./auth-tokens";

/**
 * service
 */
import { AuthenticationApiServiceProviders } from "../services";
import { AuthenticationService } from "../authentication.service";

/**
 * Array of Angular providers for authentication services
 * @constant {Provider[]} AuthenticationServiceProviders
 * @description Configures dependency injection for all authentication-related services and tokens.
 * The AuthenticationService is provided as the implementation for all authentication interfaces.
 * The AuthenticationApiServiceProviders are provided as the implementation for all authentication API interfaces.
 * 
 * @example
 * ```typescript
 * // In your module or component
 * providers: [...AuthenticationServiceProviders]
 * 
 * // Or inject specific services
 * constructor(@Inject(AUTH_JWT) private authJwt: IAuthJwtService) {}
 * constructor(@Inject(AUTH_ACCESS_TOKEN) private authAccessToken: IAuthAccessTokenService) {}
 * constructor(@Inject(AUTH_IS_LOGGED_IN) private authLoggedIn: IAuthLoggedInService) {}
 * constructor(@Inject(AUTH_CONTROLS) private authControls: IAuthControlsService) {}
 * ```
 */
export const AuthenticationServiceProviders: Provider[] = [
  AuthenticationService,
  ...AuthenticationApiServiceProviders,
  { provide: AUTH_JWT, useExisting: AuthenticationService },
  { provide: AUTH_ACCESS_TOKEN, useExisting: AuthenticationService },
  { provide: AUTH_IS_LOGGED_IN, useExisting: AuthenticationService },
  { provide: AUTH_CONTROLS, useExisting: AuthenticationService },
  { provide: AUTH_LOGIN, useExisting: AuthenticationService },
  { provide: AUTH_LOGOUT, useExisting: AuthenticationService },
  { provide: AUTH_SESSION_MANAGEMENT, useExisting: AuthenticationService },
]
